import FundINRPageContainer from "../../Component/DepositFund/FundINR/FundINR"

const FundINRPage = () => {
  return (
    <div className='page-body'>
      <FundINRPageContainer />
    </div>
  )
}

export default FundINRPage